import { api } from '@/fsd/shared/api';
import { IReconciliation, ICreateReconciliationFilters } from '../model/types';

export const createReconciliation = ({
  counterparty_id,
  date_from,
  date_to,
  organisation_id,
}: ICreateReconciliationFilters) => {
  return api.post<IReconciliation>('/api/v1/reconciliation/create/', {
    body: {
      filters: {
        counterparty_id,
        date_from,
        date_to,
        organisation_id,
      },
    },
    notify: {
      error: true,
      success: true,
    },
  });
};
